/**
 * KeepCompoundsWhole.tsx — a hyphenated compound never breaks across two lines.
 *
 * Owner repo: @thegpservice/gpsclinics-portal.
 *
 * WHY. The CTO saw "weight-loss" split across two lines on a phone and read it
 * as "weigh-loss". A compound broken at its hyphen reads as a typo on the pages
 * that most need to look careful. `hyphens: manual` does NOT prevent it: that
 * only stops the browser adding hyphens of its own, and a line may still break
 * after a hyphen that is already in the text. No CSS property stops that break,
 * so each compound ("weight-loss", "pre-authorisation", "GPhC-registered") is
 * put in its own `.gps-jux-nowrap` span (tokens.css).
 *
 * THE TEXT IS UNCHANGED: the same characters in the same order. A screen reader
 * reads the same words, copy and paste gives the same string, and an accessible
 * name (a heading's, a list item's) is the same. The only visible difference is
 * where a line may end. ⚠️ Testing Library's default text matcher reads an
 * element's OWN text nodes only, so a sentence set through this is found with
 * the whole-text matcher (`testing/wholeText.ts`), and that includes ABSENCE
 * checks: a plain `queryByText` passes vacuously against a split sentence.
 *
 * Where it is used: the celebration and /thank-you (2026-09-24), and since
 * review 2026-09-25 the journey's question heading and help, the Switch & Save
 * panel, the card step's hold explainer ("pre-" / "authorisation") and the
 * `TrustStrip` chips ("GPhC-registered").
 *
 * Letters only on both sides of the hyphen, so "month-1" and "24-hour" are left
 * alone. An en or em dash is not a hyphen and never matches.
 */
export function KeepCompoundsWhole({ text }: { text: string }) {
  const parts = text.split(/(\p{L}+(?:-\p{L}+)+)/u);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className="gps-jux-nowrap">
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </>
  );
}
